
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import '../index.css';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.js';
import { useProperty } from '../context/PropertyContext.js';
import { useNotification } from '../context/NotificationContext.js';

const UpdateProfileModal = ({ isOpen, onClose }) => {
  const serverUrl = 'https://osdevhub.com/homify_backend/api/properties';
  

    const navigate = useNavigate();
    const {user, updateProfile, authIsLoading} = useAuth();
    const {postNotification} = useNotification();
    const user_id = user.id

  const [formData, setFormData] = useState({
    name: user.name,
    email: user.email,
    phone: user.phone,
    role: user.role,
  });


  useEffect(() => {
    if(user){
        setFormData({
            name: user.name || '',
            email: user.email || '',
            phone: user.phone || '',
            role: user.role || '',
        })
    }
  }, [user])
  

  const [error, setError] = useState(null);
  const modalRef = useRef(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleSave = async () => {


    try {
        await updateProfile(user_id, formData)
        onClose();
        
        const notifyData ={
          message: `You just successfully updated your profile  `,
          type: 'personal',
          user_id: user.id,
          sender_id: user.id,
          url: `/dashboard/profile`
        }

        await postNotification(notifyData)
    } catch (err) {
      console.error("Update error:", err);
      setError("Failed to update property.");
    }
  };

  

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  

  return (
    <div className="modal-container">
      <div className="userdata-modal-content" ref={modalRef}>
        <div className="add-text-header">
          <h3>Update Profile</h3>
          <span onClick={onClose} className="close">&times;</span>
        </div>
        <div id="user-data-content-container-location" className="margin-top">
          <form className="biodata-form">
            <div className="three-forms">
              <div className="form_element">
                <label className="form-label" htmlFor="name_of_property">Name</label>
                <input
                  className="modal-input"
                  type="text"
                    id="name" 
                    name="name"
                  value={formData.name}
                  onChange={handleChange}
                />
              </div>
              <div className="form_element">
                <label className="form-label" htmlFor="address">Email</label>
                <input
                  className="modal-input"
                  type="email" 
                  id="email" 
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                />
              </div>
              <div className="form_element">
                <label className="form-label" htmlFor="price">Phone</label>
                <input
                  className="modal-input"
                    type="tel" 
                    id="phone" 
                    name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="three-forms">
     
              <div className="form_element">
                <label className="form-label" htmlFor="transaction">Role</label>
                <select
                  className="modal-input"
                  id="role"
                  name="role"
                  value={formData.role}
                  onChange={handleChange}
                >
                 <option value="" disabled>Select your role</option>
              <option value="buyer">Buyer</option>
              <option value="seller">Seller</option>
              <option value="agent">Agent</option>
                </select>
              </div>
            </div>
 
            {error && <p className="error-message">{error}</p>}
            <div className="modal-button-container margin-bottom">
              <button type="button" className="generate-button" onClick={handleSave}>
                {
                  authIsLoading ? 'Updating...' : 'Update'
                }
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default UpdateProfileModal;
